export default __webpack_public_path__ + "static/greenhouse-076e24d3c2a9c2db347e63ea80460622.svg";